import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Sprache der Seite auszeichnen, damit Browser-Übersetzer (z. B. Google Translate) greifen
document.documentElement.lang = "de";
document.documentElement.removeAttribute("translate");

// Titel sofort setzen – noch bevor React startet –, damit Suchmaschinen und
// Browser-Tabs nie den generischen Platzhaltertitel des Builds sehen.
document.title = "Hot Sales Girl werden in 8 Wochen | Hot Sales Girls Academy";

/**
 * Ladehinweise für den Browser: Verbindungen zu Schriften und Bild-CDN werden
 * sofort geöffnet, und das große Bild der Startsektion (bestimmt den
 * LCP-Messwert) wird mit hoher Priorität vorgeladen.
 */
const HERO_IMAGE = "https://cdn.magicpatterns.com/uploads/w2xwVneUjqSfENHkrW3TJ4/premium-closerin-werden-hot-sales-girls-academy.webp";
const HERO_IMAGE_MOBILE = "https://cdn.magicpatterns.com/uploads/8ix4ZMEKvfB9n38z1Ya4VS/premium-closerin-werden-hot-sales-girls-academy.mobile.webp";
function addLink(attrs: Record<string, string>) {
  const link = document.createElement("link");
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value));
  document.head.appendChild(link);
}
addLink({
  rel: "preconnect",
  href: "https://fonts.gstatic.com",
  crossorigin: ""
});
addLink({
  rel: "preconnect",
  href: "https://fonts.googleapis.com"
});
addLink({
  rel: "preconnect",
  href: "https://cdn.magicpatterns.com"
});
addLink({
  rel: "dns-prefetch",
  href: "https://i.ytimg.com"
});
addLink({
  rel: "dns-prefetch",
  href: "https://elfsightcdn.com"
});
if (window.location.pathname === "/") {
  // Handys laden die kleinere Handy-Version, alle anderen die große Version.
  addLink({
    rel: "preload",
    as: "image",
    href: HERO_IMAGE_MOBILE,
    media: "(max-width: 639px)",
    fetchpriority: "high"
  });
  addLink({
    rel: "preload",
    as: "image",
    href: HERO_IMAGE,
    media: "(min-width: 640px)",
    fetchpriority: "high"
  });
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-428" data-mp="ads5z7340xzx" />);
}